import comuni from "const/comuni.json";
import { useState } from "react";
import AsyncSelect from "react-select/async";

const comuniOk = comuni.map((comune) => {
	return {
		...comune,
		label: comune.comune + "(" + comune.provincia + ")",
	};
});

export default function SelectComune(props) {
	const [isLoading, setIsLoading] = useState(false);

	const customFilterOption = (rawInput) => {
		const inputValue = rawInput.toUpperCase();

		// Match the option label against the input value
		return comuniOk.filter((i) => i.label.toUpperCase().startsWith(inputValue));
	};

	const comuni = async (ass) => {
		return new Promise((res) => {
			setIsLoading(true);

			if (ass.length > 1) {
				let list = customFilterOption(ass);

				setTimeout(() => {
					setIsLoading(false);
					res(list);
				}, 500);
			} else {
				setIsLoading(false);
				let obj = [
					{
						id: 1,
						label: "digitare almeno due caratteri",
						value: null,
						comune: null,
						provincia: null,
						cap: null,
					},
				];
				res(obj);
			}
		});
	};
	return (
		<AsyncSelect
			value={props.value}
			placeholder={props.placeholder || "Comune"}
			onChange={props.onSelect}
			noOptionsMessage={() => {
				return <p>Nessun comune trovato</p>;
			}}
			loadOptions={comuni}
			isLoading={isLoading}
			loadingMessage={() => {
				return "Inserire almeno 3 caratteri";
			}}
		/>
	);
}
